export const usersSmsSubscriptionGroupsForFilter = "/users/sms_subscription_groups_for_filter";
